import { useEffect, useState } from "react";
import settings from "../../apiConfigs/settings";
import Button from "../../designComponents/Button";
import requestAPI from "../../utils/requestAPI";
import {
  AcceptButton,
  ButtonsSection,
  Card,
  SectionTitle,
} from "../Properties/Details/styles";
import {
  RenderAmenityObject,
  RenderIcons,
} from "../../designComponents/Table/renderMethods";
import Modal from "../../designComponents/Modal";
import MediaUploader from "../../designComponents/MediaUpload/MediaUpload";
import { uploadFilesToS3OnlyKeys } from "../../utils/s3Upload";
import { toast } from "react-toastify";
import LabelInputField from "../../designComponents/LabelInputField/LabelInputField";

const AmenitiesIcon = () => {
  const [loading, setLoading] = useState(false);
  const [title, setTitle] = useState<string>("");
  const [amenity, setAmenityIcons] = useState<{ icon: string; _id: string }[]>(
    []
  );
  const [addModal, setAddModal] = useState<boolean>(false);
  const [amenitiesData, setAmenitiesData] = useState<
    { icon: string; title: string; _id: string }[]
  >([]);
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [uploadedFile, setUploadedFile] = useState<File | null>(null);
  const getAmenityIcons = async () => {
    const response = await requestAPI(settings.getAmenitiesIcon());
    setAmenityIcons(response.data);
  };
  const getAmenitiesData = async () => {
    const response = await requestAPI(settings.getAmenities());
    setAmenitiesData(response);
  };
  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    const file = e.dataTransfer.files[0];
    setUploadedFile(file);
  };
  console.log(amenity);
  useEffect(() => {
    getAmenityIcons();
    getAmenitiesData();
  }, []);
  const handleDeleteClick = async (id: string) => {
    try {
      await requestAPI(settings.deleteAmenityIcon(id));
      toast.success("Succefully Deleted");
      getAmenityIcons();
    } catch (error: any) {
      toast.error(error.message);
    }
  };
  const handleAddAmenities = async () => {
    let providedUrl;
    setLoading(true);
    try {
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "Amenities",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(
            settings.addAmenity({ title: title, icon: providedUrl })
          );
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(
          settings.addAmenity({ title: title, icon: providedUrl })
        );
      }
      getAmenitiesData();
      setAddModal(false);
      toast.success("Successfully Added");
      providedUrl = "";
      setUploadedFile(null);
      setTitle("");
    } catch (error: any) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };
  const handleUpload = async () => {
    let providedUrl;

    try {
      console.log(uploadedFile, "file");
      if (uploadedFile && typeof uploadedFile !== "string") {
        const uploadFiles = await uploadFilesToS3OnlyKeys({
          category: "assets",
          fileUri: [uploadedFile],
          assetsCategory: "assetsCategory",
        });
        if (uploadFiles && uploadFiles.length > 0) {
          providedUrl = uploadFiles[0];
          await requestAPI(settings.addAmenityIcon({ icon: providedUrl }));
        }
      } else if (typeof uploadedFile === "string") {
        providedUrl = uploadedFile;
        await requestAPI(settings.addAmenityIcon({ icon: providedUrl }));
      }
      getAmenityIcons();
      setOpenModal(false);
      toast.success("Successfully Added Icon");
      providedUrl = "";
      setUploadedFile(null);
    } catch (error: any) {
      toast.error(error.message);
    }
  };

  return (
    <div>
      <Card style={{ margin: 0 }}>
        <ButtonsSection>
          <SectionTitle>Amenities Icons</SectionTitle>
          <AcceptButton
            onClick={() => {
              setOpenModal(true);
            }}
          >
            Add icon
          </AcceptButton>
          <Modal
            isOpen={openModal}
            onClose={() => {
              setOpenModal(false);
            }}
            halfWidth={true}
            title="Pick a Icon"
          >
            <MediaUploader
              label="Amenity Icon"
              onChange={(e) => {
                const file = e.target.files?.[0] || null;
                setUploadedFile(file);
              }}
              style={{
                container: { paddingTop: 10, gap: 6 },
                label: { paddingBottom: 10, color: "#555A77" },
                dropzone: { background: "#F1EFFB" },
              }}
            ></MediaUploader>
            <ButtonsSection style={{ paddingTop: 10 }}>
              <AcceptButton
                onClick={() => {
                  handleUpload();
                }}
              >
                Add Icon
              </AcceptButton>
            </ButtonsSection>
          </Modal>
        </ButtonsSection>
        <RenderIcons
          icons={amenity}
          onDelete={(id) => {
            handleDeleteClick(id);
          }}
        ></RenderIcons>
        <ButtonsSection>
          <SectionTitle>Amenities</SectionTitle>
          <AcceptButton
            onClick={() => {
              setAddModal(true);
            }}
          >
            Add Amenities
          </AcceptButton>
        </ButtonsSection>
        <RenderAmenityObject
          objects={amenitiesData}
          enableDelete
          refetch={getAmenitiesData}
        ></RenderAmenityObject>
      </Card>
      <Modal
        halfWidth={true}
        isOpen={addModal}
        onClose={() => {
          setAddModal(false);
        }}
      >
        <LabelInputField
          label="Title"
          name="text"
          onChange={(e) => {
            setTitle(e.target.value);
          }}
          style={{
            label: {
              fontSize: "14px",
              fontWeight: "500px",
              color: "#555A77",
            },
            input: {
              height: 50,
              border: "1px solid #F1EFFB",
              padding: 8,
              background: "#F1EFFB",
              borderRadius: 6,
              width: "100%",
            },
            container: {
              display: "flex",
              flexDirection: "column",
              gap: 6,
              paddingTop: 14,
            },
          }}
        ></LabelInputField>
        <MediaUploader
          label="Amenity Icon"
          onChange={(e) => {
            const file = e.target.files?.[0] || null;
            setUploadedFile(file);
          }}
          style={{
            container: { paddingTop: 10, gap: 6 },
            label: { paddingBottom: 10, color: "#555A77" },
            dropzone: { background: "#F1EFFB" },
          }}
        ></MediaUploader>
        <AcceptButton
          style={{ marginTop: 10 }}
          onClick={() => {
            handleAddAmenities();
          }}
        >
          Add
        </AcceptButton>
      </Modal>
    </div>
  );
};

export default AmenitiesIcon;
